function Page404() {
  return <>The page is not found</>
}

export default Page404
